export const transactionStyles = ({ isMobileScreen }) => ({
    tabsListContainer: {
        width: '100%',
        background: (theme) => (theme.palette.mode === 'dark' ? '#212936' : 'white'),
        borderBottom: (theme) =>
            `1px solid ${theme.palette.mode === 'dark' ? '#394150' : '#E5E6EB'}`,
    },
    tabsContainer: {
        p: isMobileScreen ? '10px 10px' : '15px 15px',
    },
    stackStyles: {
        background: (theme) =>
            theme.palette.mode === 'dark' ? 'transparent' : 'rgb(244, 244, 246)',
        minHeight: '60px',
        borderRadius: '5px',
        padding: '1rem 2rem',
    },
});
